// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2RvaO","right":"styles_right__UYHFI"};